export default __webpack_public_path__ + "media/color/brd-2eca6cb7.svg";